var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589417,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FFF8CD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7324_36262)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7324_36262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5894H13C12.4 16.5894 12 16.9894 12 17.5894V27.5894C12 28.1894 12.4 28.5894 13 28.5894H27C27.6 28.5894 28 28.1894 28 27.5894V17.5894C28 16.9894 27.6 16.5894 27 16.5894ZM23.1 26.5894H16.9C16.5 25.1894 15.4 24.0894 14 23.6894V21.4894C15.4 21.0894 16.5 19.9894 16.9 18.5894H23.2C23.6 19.9894 24.7 21.0894 26.1 21.4894V23.7894C24.6 24.0894 23.5 25.1894 23.1 26.5894Z",
    fill: "#FFDE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5894C21.1046 24.5894 22 23.694 22 22.5894C22 21.4848 21.1046 20.5894 20 20.5894C18.8954 20.5894 18 21.4848 18 22.5894C18 23.694 18.8954 24.5894 20 24.5894Z",
    fill: "#FFDE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 12.5894H14V14.5894H26V12.5894Z",
    fill: "#FFDE03"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7324_36262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7324_36262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMoneyIcon);
export default __webpack_public_path__ + "static/media/yellow-money-icon.1415682f7ffbf5c362bbec1593532f37.svg";
export { ForwardRef as ReactComponent };